import React, { useContext } from 'react'

//Node Modules
import Dropdown from 'react-bootstrap/Dropdown'
import { useTranslation } from 'react-i18next'

//Components
import { CheckmarkIcon } from 'components/SASIcon'


//Context
import { LanguageContext } from 'context/language-context'

//Styles
import styles from './Item.module.scss'

//Util
import { VERSION_LTS_IND } from 'util/constants'

interface Props {
  to: string
  cdc?: boolean
  lts?: boolean
  ltsOverride?: boolean
  label: string
  active?: boolean
}

const Item = ({to, cdc, lts, ltsOverride, label, active}:Props) => {

  const currentLang = useContext(LanguageContext)
  const { t } = useTranslation()

  const ltsTitle = t('helpcenter-gui-icu.mainnav.version.menu.lts.title')

  const handleKeyboard = (e: React.KeyboardEvent) => {
    if (e.keyCode === 32) {
      let target = e.currentTarget as HTMLElement 
      target.click()
    }
  }

  const link = () => {
    return (
      <a href={to} className={`${styles.item} dropdown-item` } onKeyDown={handleKeyboard} title={currentLang !== 'en' && lts && !ltsOverride ? ltsTitle+' '+label : ''}>
        { active && <span className={styles.active}><CheckmarkIcon /></span>}
        {cdc && <span className={`${styles.ltsContainer} ${lts && !ltsOverride ? styles.show : ''}`}>{VERSION_LTS_IND}</span>}
        { label }
      </a>
    )
  }
  return <Dropdown.Item as={link} />
}

export default Item